const url = '/api/v1/gradebook/';

export const state = {
    studentData: [],
    modalEditStudent: false,
    modalTransferToClass: false,
    modalExpel: false,

}, modules = {
    loading: 'loading', alert: 'alert', gradebook: 'gradebook',
}

export const getters = {
    studentData: state => state.studentData,
    modalEditStudent: state => state.modalEditStudent,
    modalTransferToClass: state => state.modalTransferToClass,
    modalExpel: state => state.modalExpel,
}

export const mutations = {

    setData(state, {type, items}) {
        state[type] = items;
    },

    clearData(state, {types}) {
        for (let key in state) {
            for (let type in types) {
                key === types[type] ? state[key] = null : false
            }
        }
    }
}

export const actions = {

    // edit student
    async showModalEditStudent({commit, state, dispatch}, params) {
        dispatch('loading/addLoading', '', {root: true})
        const {data: {studentData}} = await axios.get(url + 'get-full-student-data', {
            params: {
                'student_id': params.student.id
            }
        });
        dispatch('loading/subLoading', '', {root: true})

        commit('setData', {type: 'studentData', items: studentData});
        commit('setData', {type: 'modalEditStudent', items: true});
    },

    // Transfer To Class
    async showModalTransferToClass({commit, state, dispatch}) {
        commit('setData', {type: 'modalEditStudent', items: false});
        commit('setData', {type: 'modalTransferToClass', items: true});
    },

    async transferToClass({commit, state, dispatch}, params) {
        try {
            dispatch('loading/addLoading', '', {root: true})

            await axios.post(url + 'transfer-to-class', {
                'student_id': params.studentId,
                'old_class': params.oldGroup,
                'new_class': params.newGroup,
            });

            dispatch('gradebook/gradebook/getTable', '', {root: true})
            dispatch('loading/subLoading', '', {root: true})
            commit('setData', {type: 'modalTransferToClass', items: false});
        } catch (err) {
            console.log(err)
            dispatch('loading/subLoading', '', {root: true})
        }
    },
    // end Transfer To Class

    // Expel Student
    async showModalExpel({commit, state, dispatch}) {
        commit('setData', {type: 'modalEditStudent', items: false});
        commit('setData', {type: 'modalExpel', items: true});
    },

    async expelStudent({commit, state, dispatch}, params) {
        try {
            dispatch('loading/addLoading', '', {root: true})

            await axios.post(url + 'expel-student', {
                'student_id': params.studentId,
                'group_id': params.groupId,
            });

            dispatch('gradebook/gradebook/getTable', '', {root: true})
            dispatch('loading/subLoading', '', {root: true})

        } catch (err) {
            console.log(err)
            dispatch('loading/subLoading', '', {root: true})
        }
    },
    // end Expel Student

    hideModal({commit, state, dispatch}, modal) {
        commit('setData', {type: modal, items: false});
    },
    // end modals
};